import React from "react";
import { mapTableRows } from "../../../../../utils";
import { Button, TableAdv } from "../../../../../components";
import { useNavigate } from "react-router-dom";
const campaignNames = [
  "Email campaign 1",
  "AI Call campaign 1",
  "SMS campaign 1",
  "Whatsapp campaign 1",
];
const campaignTypes = ["Email", "AI Calls", "SMS", "Whatsapp"];

const JobCampaign = ({selectedJobUiid}) => {
  const navigate = useNavigate();
  const columns = [
    {
      key: "sNo",
      label: "S.No",
      columnMenu:false
    },
    {
      key: "campaignName",
      label: "Campaign Name",
      columnMenu:false
    },
    {
      key: "campaignType",
      label: "Campaign Type",
      columnMenu:false
    },
    {
      key: "status",
      label: "Status",
      columnMenu:false
    },
  ];
  const rows = Array.from({ length: 4 }, (_, i) => ({
    sNo: i + 1,
    campaignName:
      campaignNames[Math.floor(Math.random() * campaignNames.length)],
    campaignType:
      campaignTypes[Math.floor(Math.random() * campaignTypes.length)],
    status: "Active",
  }));
  const mappedRows = mapTableRows(rows, columns);
  return (
    <div>
      <TableAdv
        tableId={"jobs_jobdetails_jobcampaigns_table"}
        rows={mappedRows}
        columns={columns}
        toolbarRight={{
          search: true,
          fullScreen: true,
          add: [
            {
              component: (
                <div className="flex items-center gap-2">
                  <Button
                    size="sm"
                    title={"Create Campaign"}
                    className=""
                    onClick={() => {
                      navigate("/ats/create-campaign", { state: { selectedJobUiid }});
                    }}
                  />
                </div>
              ),
            },
          ],
        }}
      />
    </div>
  );
};

export default JobCampaign;
